<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<mat-form-field [title]="title" appearance="outline" class="lf-field lf-dropdown">
  <mat-select
    panelClass="lf-dropdown-overlay"
    [formControl]="formControl"
    [title]="formControl.value"
    (selectionChange)="onValueChanged()"
    [compareWith]="compareWith"
  >
    <mat-option>--</mat-option>
    @for (listOption of options; track listOption) {
      <mat-option [value]="listOption">
        {{ listOption }}
      </mat-option>
    }
  </mat-select>
  @if (getBrokenValidationRule()) {
    <mat-error>{{ fieldValidationErrorMsg | async }}</mat-error>
  }
</mat-form-field>
